import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { PageModel } from 'client/data/models/page';
import {
  buildTrimSummariesPath,
  InventoryCoreConfigurationsModel,
  InventoryTrimSummaryEntities,
} from 'client/data/models/inventory-core-configurations';
import { CorePageParams, getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { getTrimsWithLabels } from 'site-modules/shared/utils/core-page/trims-cta-utils';
import { DockedSrpLink } from 'site-modules/shared/components/docked-srp-link/docked-srp-link';
import { DockedLeadFormButton } from 'site-modules/core-page/components/docked-lead-form-button/docked-lead-form-button';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';

// TODO: Consider combining DockedSrpLink and DockedLeadFormButton after core-6958 and core-6912
export function DockedCoreButtonUI({
  params,
  vehicle,
  trims,
  sharedTrimName,
  inventoryTotalNumber,
  isCore6743Enabled,
  isCore6912Enabled,
}) {
  if (!trims) {
    return null;
  }

  const currentTrim = trims.find(({ trimName }) => trimName === sharedTrimName) || get(trims, '[0]');
  const showLeadForm = currentTrim?.hasLeadFormDealers && !params?.isDealerlessOem;

  const dockedSrpLink = (
    <DockedSrpLink
      params={params}
      showElementSelector="[data-tracking-parent='edm-entry-review-scorecard2'],.core-also-viewed-vehicles"
      inventoryTotalNumber={inventoryTotalNumber}
      trackingId="docked_srp_button"
      creativeId="new_core_dock_bottom"
      makeName={vehicle.make.name}
      modelName={vehicle.model.name}
      isCore6743Enabled={isCore6743Enabled}
      isCore6912Enabled={isCore6912Enabled}
    />
  );

  return (
    <Experiment name="core-6958-docked-leads" showDefault>
      <Recipe name="ctrl" isDefault>
        {dockedSrpLink}
      </Recipe>
      <Recipe name="chal1">
        <DockedLeadFormButton
          vehicle={vehicle}
          currentTrim={currentTrim}
          showElementSelector=".trim-simple-summary"
          creativeId="new_core_dock_bottom"
          core6958Recipe="chal1"
          showLeadForm={showLeadForm}
          fallbackFragment={dockedSrpLink}
        />
      </Recipe>
      <Recipe name="chal2">
        <DockedLeadFormButton
          vehicle={vehicle}
          currentTrim={currentTrim}
          showElementSelector=".trim-simple-summary"
          creativeId="new_core_dock_bottom"
          core6958Recipe="chal2"
          showLeadForm={showLeadForm}
          fallbackFragment={dockedSrpLink}
        />
      </Recipe>
    </Experiment>
  );
}

DockedCoreButtonUI.propTypes = {
  params: CorePageParams.isRequired,
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  trims: InventoryTrimSummaryEntities.TrimSummaries,
  sharedTrimName: PropTypes.string,
  inventoryTotalNumber: PropTypes.number,
  isCore6743Enabled: PropTypes.bool,
  isCore6912Enabled: PropTypes.bool,
};

DockedCoreButtonUI.defaultProps = {
  trims: null,
  sharedTrimName: null,
  inventoryTotalNumber: null,
  isCore6743Enabled: false,
  isCore6912Enabled: false,
};

export const propsAreEqual = (prevProps, { trims }) => !trims;
export const DockedCoreButton = connectToModel(React.memo(DockedCoreButtonUI, propsAreEqual), {
  sharedTrimName: bindToPath('sharedValues.trimName', PageModel),
  trims: bindToPath(
    ({ vehicle }) => buildTrimSummariesPath(getParamsFromVehicle(vehicle)),
    InventoryCoreConfigurationsModel,
    getTrimsWithLabels
  ),
});
